/**
 * This place where we put out
 * User definitions method
 */
export const actions = {
  getUser: 'getUser',
  searchUser: 'searchUser',
  checkUserSubscription: 'checkUserSubscription'
};

export const mutations = {
  setCurrentUser: 'setCurrentUser',
  setCurrentUserPremium: 'setCurrentUserPremium',
  setCurrentUserPremiumExpiryDate: 'setCurrentUserPremiumExpiryDate'
};

export default {
  actions,
  mutations
};
